import React from 'react';
import { InputCheckbox } from '../../../Inputs';
import TableRow from '../../TableRow/TableRow';

const ResidentialTitleFeesOwnersPremiumBody = ({
  basicPolicy,
  surveyAmendmentT1RResult,
  assessmentRecoupmentCharge,
  t19_1Result,
  totals,
  props,
}) => {
  // destructuring the totals
  const { totalOwnersPremium } = totals;

  return (
    <tbody>
      <TableRow
        type="checkbox"
        label="Basic Policy"
        valueType="currency"
        value={basicPolicy}
      />
      <TableRow
        type="checkbox"
        label="Policy Guaranty Fee"
        valueType="currency"
        value={assessmentRecoupmentCharge}
      />
      <TableRow
        type="checkbox"
        label="Survey Amendment to T-1R Policy"
        valueType="currency"
        value={surveyAmendmentT1RResult}
      />
      <TableRow
        type="checkbox"
        label="T-19.1 (Rest/Encro/Minerals)"
        valueType="currency"
        value={t19_1Result}
      />
      <TableRow
        type="checkbox"
        className="tr--result"
        label="Total Owner's Policy Premium"
        valueType="currency"
        value={totalOwnersPremium}
      />
    </tbody>
  );
};

export default ResidentialTitleFeesOwnersPremiumBody;
